import React, {PropsWithChildren} from "react";
import { observer } from "mobx-react";
import { observable, runInAction, makeObservable } from "mobx";
import { OrbitComponent } from "../../base-components/orbit-component/orbit-component";
import {ThemeDefaultIcons} from '../../../themes/defaults/icons-registry';
import { Label } from "../boxes/label";
import {Select} from "../../../basic-ui-components/form/select.component";
import {ShowcaseContentContainerBox} from "../boxes/showcase-content-container/showcase-content-container.box";

enum AvailableSizes {
    Default = "default",
    Rem2 = "2rem",
    Rem4 = "4rem",
    Rem6 = "6rem",
    Rem12 = "12rem"
}

@observer
export class IconsShowcase extends OrbitComponent {
    @observable.ref
    private color: string = "#fff";

    @observable.ref
    private size = AvailableSizes.Default;

    constructor(props: PropsWithChildren) {

        super(props);

        makeObservable(this);
    }

    componentDidMount() {
        super.componentDidMount();
        runInAction(() => {
            this.color = this.services.theme.currentTheme.colors.brandSecondary;
        })
    }

    private getIconSizeProps(inputSize: AvailableSizes) {
        switch (inputSize) {
            case AvailableSizes.Rem2:
                return 2;
            case AvailableSizes.Rem4:
                return 4;
            case AvailableSizes.Rem6:
                return 6;
            case AvailableSizes.Rem12:
                return 12;
            default:
                return undefined;
        }
    }

    render() {
        return <>
            <ShowcaseContentContainerBox style={{alignItems: "center", marginBlockEnd: "2rem"}}>
                <div>
                    <input
                        type="radio" name="icons_color" id="color_brandSecondary"
                        value={this.services.theme.currentTheme.colors.brandSecondary}
                        checked={this.color === this.services.theme.currentTheme.colors.brandSecondary}
                        onChange={() => {
                            runInAction(() => {
                                this.color = this.services.theme.currentTheme.colors.brandSecondary
                            })
                        }}
                    />
                    <Label htmlFor={"color_brandSecondary"}>brandSecondary</Label>
                </div>
                <div>
                    <input
                        type="radio" name="icons_color" id="color_brandPrimary"
                        value={this.services.theme.currentTheme.colors.brandPrimary}
                        checked={this.color === this.services.theme.currentTheme.colors.brandPrimary}
                        onChange={() => {
                            runInAction(() => {
                                this.color = this.services.theme.currentTheme.colors.brandPrimary
                            })
                        }}
                    />
                    <Label htmlFor={"color_brandPrimary"}>brandPrimary</Label>
                </div>
                <div>
                    <Select id="icon_size" value={this.size} onChange={(e) => {
                        runInAction(() => {
                            this.size = e.target.options[e.target.selectedIndex].value as AvailableSizes;
                        });
                    }}>
                        {[AvailableSizes.Rem2, AvailableSizes.Default, AvailableSizes.Rem4, AvailableSizes.Rem6, AvailableSizes.Rem12].map(size => {
                            return <option key={size} value={size}>{size}</option>
                        })}
                    </Select>
                </div>
            </ShowcaseContentContainerBox>
            <div style={{display: "flex", color: this.color, flexWrap: "wrap"}}>
                {Object.keys(ThemeDefaultIcons).map(key => {
                    let specialProps: any = {};
                    if (key === "twoCharsIcon") {
                        specialProps = {text: "test"};
                    }
                    if (key === "locationIcon") {
                        specialProps = {animated: true};
                    }
                    let TheIcon = this.services.theme.currentTheme.icons[key];
                    return <TheIcon
                        key={key}
                        size={this.getIconSizeProps(this.size)}
                        className={"showcase-" + key}
                        sizeIsHeight
                        {...specialProps}
                    />;
                })}
            </div>
        </>;
    }
}
